<script setup lang="ts">
const props = defineProps({
  is404: {
    type: Boolean,
    default: false,
  },
});

const { isHeroActive } = storeToRefs(usePageStore());
</script>

<template>
  <ClientOnly>
    <header
      class="fixed top-0 z-[999] w-full transition-all text-white duration-300 bg-transparent"
      :class="{
        ['!bg-white !text-black shadow-[0_0_20px_black]']: !isHeroActive,
        ['!bg-white !text-black  border-black']: is404,
      }"
    >
      <nav
        class="relative mx-auto flex items-center w-full max-w-[1024px] gap-10 px-10 pr-7 py-4 -md:px-6 -md:pr-3 -sm:px-4 -sm:pr-1 -sm:py-3 justify-between"
      >
        <LanguageSelector />

        <MobileNav />
      </nav>
    </header>
  </ClientOnly>
</template>
